<template>
  <div>
    <HeaderBar></HeaderBar>
    <Careers></Careers>
    <!-- <ContactUs id="contact"></ContactUs> -->
    <FooterBar></FooterBar>
  </div>
</template>

<script>

import HeaderBar from '../components/site/Header/Header'
import ContactUs from '../components/ContactUs'
import Press from '../components/site/PressHero/Press'
import FooterBar from '../components/site/Footer/Footer'
import Careers from '../components/Careers'

export default {
  components: {
    HeaderBar,
    Careers,
    ContactUs,
    FooterBar
  }
}

</script>



// WEBPACK FOOTER //
// Careers.vue?1debb40c